import {
  ChakraProvider,
  ChakraTheme,
  extendTheme,
  ThemeOverride,
} from '@chakra-ui/react'
import { Global } from '@emotion/react'
import React from 'react'

import { default as digibTheme } from '~shared-components/chakra-theme'
import { FontImportStyle } from '~shared-components/theme'

const overrideTheme = {
  styles: {
    global: () => ({
      'html, body': {
        color: 'deepPurple',
        fontFeatureSettings: '"tnum" 1, "lnum" 1',
        height: '100%',
      },
    }),
  },
} as ThemeOverride

const theme = extendTheme(overrideTheme, digibTheme as ChakraTheme)

export const AllTheTheme: React.FC = ({ children }) => (
  <ChakraProvider theme={theme}>
    <Global styles={FontImportStyle} />
    {children}
  </ChakraProvider>
)
